module.exports = __webpack_public_path__ + "static/img/index-03.0d8babc0.png";